// Share a speculative import with React.lazy. Failed preloads may be retried
// when the route actually renders (for example, after a transient network error).
export function createRouteLoader<T>(importPage: () => Promise<T>): () => Promise<T> {
  let pending: Promise<T> | undefined;
  return () => {
    if (!pending) {
      pending = importPage().catch((error) => {
        pending = undefined;
        throw error;
      });
    }
    return pending;
  };
}
